<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="hasSelection" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ displayLabel }}
        .px-1.neutral400--text |
        .text-xs.primary--text.font-medium {{ selectionLabel }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ displayLabel }}

    .white
      .font-semibold.text-sm.px-4.pt-4.pb-2 {{ $t('filter_by') }} {{ displayLabel.toLowerCase() }}
      div(v-for="(status, index) in statuses")
        .d-flex.text-sm.py-3.px-4.cursor-pointer.hover-bg(v-if="multiple" @click="clickItem(status)")
          yc-checkbox(:input-value="isChecked(status.id)" @change="clickItem(status)")
          .ml-4 {{ status.name }}
        .d-flex.text-sm.py-3.px-4(v-else)
          yc-checkbox(v-model="status.isChecked" @change="updateStatus(status)")
          .ml-4 {{ status.name }}
        v-divider.basic300(v-if="index !== statuses.length - 1")

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="hasSelection" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}

</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    statuses: {
      type: Array,
      default: (() => [])
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMenu: false,
    selectedStatus: null,
    checkedItems: [],
    selectedItems: [],
  }),
  computed: {
    displayLabel () {
      return this.label || this.$t('status')
    },
    disabledButton () {
      if (this.multiple) return this.checkedItems.length === 0
      return !this.statuses.filter(i => i.isChecked === true).length > 0
    },
    hasSelection () {
      return this.multiple ? this.selectedItems.length > 0 : !!this.selectedStatus
    },
    selectionLabel () {
      if (this.multiple) return this.getSelectedStatuses()
      return this.selectedStatus ? this.selectedStatus.name : ''
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      }
    },
    showMenu (value) {
      if (!value && this.multiple) {
        this.checkedItems = [...this.selectedItems]
        this.syncCheckboxes()
      }
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          if (this.multiple) {
            const ids = this.filter.value.split(',')
            const items = []
            this.statuses.forEach(item => {
              if (ids.includes(item.id)) items.push({ id: item.id, name: item.name })
            })
            this.checkedItems = JSON.parse(JSON.stringify(items))
            this.selectedItems = JSON.parse(JSON.stringify(items))
          } else {
            this.statuses.forEach(item => {
              if (item.id === this.filter.value) {
                item.isChecked = true
                this.selectedStatus = item
              }
            })
          }
        }
      }
    },
    updateStatus (value) {
      this.statuses.forEach(item => {
        if (value.id !== item.id) item.isChecked = false
      })
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.selectedStatus = null
      this.checkedItems = []
      this.selectedItems = []
      this.statuses.forEach(item => item.isChecked = false)
    },
    apply () {
      this.showMenu = false
      if (this.multiple) {
        this.selectedItems = [...this.checkedItems]
        const value = this.checkedItems.map(i => i.id).join(',')
        this.$emit('update:filter', this.checkedItems.length ? { key: 'statuses', value } : {})
      } else {
        this.selectedStatus = null
        this.statuses.forEach(item => {
          if (item.isChecked) this.selectedStatus = item
        })
        this.$emit('update:filter', this.selectedStatus ? { key: 'statuses', value: this.selectedStatus.id } : {})
      }
    },
    clickItem (item) {
      const index = this.checkedItems.findIndex(i => i.id === item.id)
      if (index > -1) {
        this.checkedItems.splice(index, 1)
      } else {
        this.checkedItems.push({ id: item.id, name: item.name })
      }
    },
    isChecked (id) {
      return this.checkedItems.some(i => i.id === id)
    },
    syncCheckboxes () {
      this.statuses.forEach(item => {
        item.isChecked = this.selectedItems.some(i => i.id === item.id)
      })
    },
    getSelectedStatuses () {
      const count = this.selectedItems.length
      if (count === 0) return ''
      if (count <= 2) return this.selectedItems.map(x => x.name).join(', ')
      return `${count} selected`
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>